import React, {FC, useState} from "react";
import styled from "@emotion/styled";

import {useDispatch} from "react-redux";
import {useSelector} from "../../../../../../../../../redux/store";
import {
  createPropertyAccessibilityInfo,
  updatePropertyAccessibilityInfo,
} from "../../../../../../../../../redux/actions/propertyActions";
import {useParams} from "react-router-dom";
import {
  PropertyAccessibilityInfo,
  PropertyAccessibilityInfosRequest
} from "../../../../../../../../../models/PropertyAccessibilityInfo";
import {CheckboxGradient} from "../../../../../../../../components/CheckboxGradient";
import {Question} from "../../../../../../../../../models/Question";

const Row = styled.tr`
  height: 58px;
  width: 100%;
  border-bottom: 1px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.05);
`

const Td = styled.td`
  text-align: center;
  vertical-align: middle;
  padding: 0 5px;
  max-width: 1106px;
`

type PropsType = {
  question: Question
  propertyAccessibilityInfo: PropertyAccessibilityInfo[] | null;
}

const TableInformationByDisabilityRow: FC<PropsType> = ({
  question,
  propertyAccessibilityInfo,
}) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.authReducer.user);
  const [loading,setLoading] = useState(false)
  const params: {id: string} = useParams()

  const handleChangeAccessibilityInfo = async (displayed: boolean) => {
    setLoading(true)
    if (propertyAccessibilityInfo && propertyAccessibilityInfo.length > 0) {
      const foundInfo = propertyAccessibilityInfo
        .find((i) => i.question === question.id)
      if (foundInfo) {
        const newData: PropertyAccessibilityInfosRequest = {is_displayed: displayed}
        await dispatch(updatePropertyAccessibilityInfo(newData, user!.token, foundInfo.id))
      } else {
        const data = {
          answer: 'yes',
          is_displayed: true,
          property: params.id,
          question: question.id
        }
        await dispatch(createPropertyAccessibilityInfo(data, user!.token))
      }
    } else {
      const data = {
        answer: 'yes',
        is_displayed: true,
        property: params.id,
        question: question.id
      }
      await dispatch(createPropertyAccessibilityInfo(data, user!.token))
    }
    setLoading(false)
  }

  const isChecked = (question: Question, propertyAccessibilityInfo: PropertyAccessibilityInfo[] | null) => {
    if (propertyAccessibilityInfo && propertyAccessibilityInfo.length > 0) {
      const foundInfo = propertyAccessibilityInfo
        .find((i) => i.question === question.id)
      if (foundInfo && foundInfo.is_displayed) {
        return true
      }
    }
    return false
  }

  const limitOfPropertyAccessibilityInfo = (question: Question, info: PropertyAccessibilityInfo[] | null) => {
    if (info && info.length > 4) {
      const moreThanFour = info.filter((i) => i.is_displayed).length > 4
      return moreThanFour && !isChecked(question, info)
    }
    return false
  }

  return (
    <Row>
      <Td>{question.answer_text_yes}</Td>
      <Td>
        <CheckboxGradient
          disabled={loading || limitOfPropertyAccessibilityInfo(question, propertyAccessibilityInfo)}
          checked={isChecked(question, propertyAccessibilityInfo)}
          onChange={(e) => handleChangeAccessibilityInfo(e.target.checked)}
        />
      </Td>
      <Td style={{width: 220, textAlign: 'right', marginRight: 20}}/>
    </Row>
  )
}

export default TableInformationByDisabilityRow
